import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {

  constructor() { }



  calculateTotalTime(startTime, endTime) {
    let timeStart = new Date("01/01/2007 " + startTime).getHours();
    let timeEnd = new Date("01/01/2007 " + endTime).getHours();
    let hourDiff = timeEnd - timeStart;
    // Here's the working fiddle http://jsfiddle.net/VnwF7/4/
    // UPDATE - to calculate if we are including the next day. Just add the following if block
    if (hourDiff < 0) {
      hourDiff = 24 + hourDiff;
    }
    let startMinute = new Date("01/01/2007 " + startTime).getMinutes()
    let endMinute = new Date("01/01/2007 " + endTime).getMinutes()
    let minutesDiff = endMinute - startMinute
    console.log("ths is the minutes diff", minutesDiff);
    let tempHours = hourDiff * 60
    let tempMinutes = Math.abs(tempHours + minutesDiff)
    let m = (tempMinutes % 60);
    let h = (tempMinutes - m) / 60;
    let diffrence = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();
    return diffrence
  }


  /**
   * @param logs One day multiple logs
   * Calculate multiple logs for one day 
   * Which return total working hours for one day with different jobs
   * Also return total working plus travel hours for one day with different jobs
   */
  calculateTotalMultipleTimelogs(logs) {
    let timeCalculated = {
      // tWorking: '00:00',
      tTraveling: '00:00',
      // travelWorking: '00:00'
    }
    let tTraveling
    let tWorking
    let travelWorking
    if (logs && logs.length) {
      let thourH: any = '00';
      let thourM: any = '00';
      let whourH: any = '00';
      let whourM: any = '00';
      let twhourH: any = '00';
      let twhourM: any = '00';
      // lodash.forEach(logs, (day, index) => {
      for (let i = 0; i < logs.length; i++) {
        console.log("here is single day value!!!!!!", logs[i])
        let thour = logs[i].travel !== "" ? logs[i].travel.split(':') : '00:00'
        // let whour = logs[i].workingHours !== "" ? logs[i].workingHours.split(':') : '00:00'
        // let twhour = logs[i].totalHours !== "" ? logs[i].totalHours.split(':') : '00:00'
        // console.log("ALL TYPES OF LOGS", thour, whour, twhour)
        thourH = Number(thourH) + Number(thour[0]);
        thourM = Number(thourM) + Number(thour[1]);

        // whourH = Number(whourH) + Number(whour[0]);
        // whourM = Number(whourM) + Number(whour[1]);

        // twhourH = Number(twhourH) + Number(twhour[0]);
        // twhourM = Number(twhourM) + Number(twhour[1]);
      }
      console.log("THIS IS THOURS AND TMINUTES", thourH, thourM)
      // })
      if (thourM > 60) {
        thourH = thourH + Math.floor(thourM / 60)
        thourM = thourM % 60
        thourH = this.addPaddingValue(thourH, 2)
        thourM = this.addPaddingValue(thourM, 2)
        tTraveling = thourH + ":" + thourM
      } else if (thourM == 60) {
        thourH = this.addPaddingValue(thourH + 1, 2)
        thourM = this.addPaddingValue(thourM - 60, 2)
        tTraveling = thourH + ":" + thourM
      }
      else {
        thourH = this.addPaddingValue(thourH, 2)
        thourM = this.addPaddingValue(thourM, 2)
        tTraveling = (thourH) + ":" + (thourM)
      }
      if (whourM > 60) {
        whourH = whourH + Math.floor(whourM / 60)
        whourM = whourM % 60
        whourH = this.addPaddingValue(whourH, 2)
        whourM = this.addPaddingValue(whourM, 2)
        tWorking = whourH + ":" + whourM
      } else if (whourM == 60) {
        whourH = this.addPaddingValue(whourH + 1, 2)
        whourM = this.addPaddingValue(whourM - 60, 2)
        tWorking = whourH + ":" + whourM
      }
      else {
        whourH = this.addPaddingValue(whourH, 2)
        whourM = this.addPaddingValue(whourM, 2)
        tWorking = whourH + ":" + whourM
      }
      if (twhourM > 60) {
        twhourH = twhourH + Math.floor(twhourM / 60)
        twhourM = twhourM % 60
        twhourH = this.addPaddingValue(twhourH, 2)
        twhourM = this.addPaddingValue(twhourM, 2)
        travelWorking = twhourH + ":" + twhourM
      } else if (twhourM == 60) {
        twhourH = this.addPaddingValue(twhourH + 1, 2)
        twhourM = this.addPaddingValue(twhourM - 60, 2)
        travelWorking = twhourH + ":" + twhourM
      }
      else {
        twhourH = this.addPaddingValue(twhourH, 2)
        twhourM = this.addPaddingValue(twhourM, 2)
        travelWorking = twhourH + ":" + twhourM
      }
      timeCalculated.tTraveling = tTraveling
      // timeCalculated.tWorking = tWorking
      // timeCalculated.travelWorking = travelWorking
      console.log("timeCalculated------>", timeCalculated);
      return timeCalculated
    } else return timeCalculated
  }



  addPaddingValue(num, numZeros) {
    // console.log("h is calling or not", h);
    let n = Math.abs(num);
    // console.log("what is the n value", n);

    let zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
    // console.log("what is the zero value", zeros);

    let zeroString = Math.pow(10, zeros).toString().substr(1);
    // console.log("what is the value of zero strinf", zeroString);

    if (num < 0) {
      zeroString = '-' + zeroString;
    }

    return zeroString + n;
  }
}
